// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"SearchBox_searchbox__3jcED"};